export var drawImageOnCanvas = function (canvasElement, imageSrc, dx, dy, scaleFactor) {
    if (canvasElement) {
        var ctx_1 = canvasElement.getContext("2d");
        var image_1 = new Image();
        image_1.src = imageSrc;
        image_1.onload = function () {
            if (ctx_1) {
                ctx_1.drawImage(image_1, dx, dy, image_1.width * scaleFactor, image_1.height * scaleFactor);
            }
        };
    }
};
export var getScaleFactor = function (canvasElement, image) {
    var widthScaleFactor = canvasElement.width / image.width;
    var heightScaleFactor = canvasElement.height / image.height;
    return Math.min(widthScaleFactor, heightScaleFactor);
};
